module.exports = __webpack_public_path__ + "img/Rendimiento-R.52961abf.png";